$(".selectDate").on('change', function () {
	var request;
	if (window.XMLHttpRequest) {
		request = new XMLHttpRequest();
	}
	let fileName = date + $(this).val();
	request.open('GET', fileName);
	request.onreadystatechange = function () {
		if ((request.readyState === 4) && (request.status === 200)) {
			var res = JSON.parse(request.responseText);
			$(".selectTime option").remove();
			$('select.selectTime').append(res.data);
			$('.selectpicker').selectpicker("refresh");
			
			if(res.message) {
				$('.requestDateMessage').removeClass('d-none');
				$('.requestDateMessage').append(res.message)
			} else {
				$('.requestDateMessage').addClass('d-none');

			}
		}
	};
	request.send();
	
	
})